import OBTAutoValueBinder from './OBTAutoValueBinder';
export default OBTAutoValueBinder;
